import {apiGet, extractPayloadFromResponse} from "@/services/apiService";

export default async function tagAddedToQueueItemCallbackHandler(authToken, collectionUuid, tagUuid, userAccountUuid): Promise<void> {
    try {
        const response = await apiGet(`/system/queueTagAdded/${collectionUuid}/${tagUuid}/${userAccountUuid}`, authToken);

        const payload = await extractPayloadFromResponse(response);

        if (payload?.error) {
            console.log(payload?.error);
        }

        console.log(payload.success);
    } catch (error: any) {
        console.log(error.message);
    }
}
